module.exports = __webpack_public_path__ + "static/media/ll.61064481.png";